
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tourism-intro",
      function () {
        return require("private-next-pages/tourism-intro/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tourism-intro"])
      });
    }
  